import ROLE_TYPES from "../helpers/constant/role-types";

// eslint-disable-next-line
export default {
  publisherAdmin: [ROLE_TYPES.PUBLISHER, ROLE_TYPES.SUPER_ADMIN],
  admin: [ROLE_TYPES.SUPER_ADMIN],
  publisher: [ROLE_TYPES.PUBLISHER],
  all: [ROLE_TYPES.PUBLISHER, ROLE_TYPES.SUPER_ADMIN]
};
